import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import {
  addInvitee,
  updateInvitee,
  addTable,
  fetchAllArrangementsWithGuests,
  deleteInvitee,
  deleteTable,
} from "../Service";
import { useTheme } from "@mui/material/styles";
import {
  Button,
  TextField,
  InputAdornment,
  Alert,
  IconButton,
  Collapse,
  Box,
  Typography,
  useMediaQuery,
  CircularProgress,
  Stack,
} from "@mui/material";
import GuestTable from "../components/GuestTable";
import AddInviteeDialog from "../components/AddInviteeDialog";
import EditInviteeDialog from "../components/EditInviteeDialog";
import GuestFilterTabs from "../components/GuestFilterTabs";
import AddTableDialog from "../components/AddTableDialog";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PostAddIcon from "@mui/icons-material/PostAdd";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Fab from "@mui/material/Fab";
import AppBar from "@mui/material/AppBar";
import Navbar from "../components/Navbar";
import Toolbar from "@mui/material/Toolbar";
import MenuIcon from "@mui/icons-material/Menu";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DueSwitchForm from "../components/DueSwitch";
import SmoothReceptionSwitchForm from "../components/SmoothReceptionSwitch";
import EachTableAddInviteeDialog from "../components/EachTableAddinviteeDialog";
import { exportGuestsCSV } from "../components/CsvExport";

// const FRONT_URL = process.env.REACT_APP_FRONT_URL;
const FRONT_URL = `${window.location.protocol}//${window.location.host}`;

// 全角/半角の統一、カタカナ→ひらがな、空白削除、英字は小文字化
const normalizeJP = (s = "") =>
  s
    .toString()
    .normalize("NFKC")
    .toLowerCase()
    // カタカナ→ひらがな
    .replace(/[\u30A1-\u30F6]/g, (ch) =>
      String.fromCharCode(ch.charCodeAt(0) - 0x60)
    )
    // 半角/全角スペースを除去
    .replace(/[\s\u3000]/g, "");

// 検索語を空白でトークン分割し、全トークンがどれかの候補文字列に含まれるかチェック
const tokenizedMatch = (q, haystacks) => {
  const raw = (q ?? "").toString().trim();
  if (!raw) return true; // 未入力ならマッチ扱い

  const tokens = raw
    .normalize("NFKC")
    .split(/[\s\u3000]+/)
    .filter(Boolean)
    .map(normalizeJP);

  return tokens.every((t) => haystacks.some((h) => h.includes(t)));
};

const GuestsManage = ({ navbar }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [searchTerm, setSearchTerm] = useState("");
  const [guestAddModalIsOpen, setGuestAddModalIsOpen] = useState(false);
  const [tableModalIsOpen, setTableModalIsOpen] = useState(false);
  const [selectedWill, setSelectedWill] = useState("all");
  const [selectedSide, setSelectedSide] = useState("all");
  const [newInvitee, setNewInvitee] = useState({
    nick_name: "",
    first_name: "",
    last_name: "",
    gender: "N",
    travel_cost: "no",
    side: "",
    allergy: "",
    arrangement_id: "",
    will: "",
  });
  const [newTable, setNewTable] = useState({
    arrangement_name: "",
    side: "",
  });
  const [linkModalIsOpen, setLinkModalIsOpen] = useState(false);
  const [currentLink, setCurrentLink] = useState("");
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [editInvitee, setEditInvitee] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  const [arrangements, setArrangements] = useState([]);
  const [unarrangedGuests, setUnarrangedGuests] = useState([]);
  const [selectedArrangementId, setSelectedArrangementId] = useState(null);
  const [appbarHeight, setAppbarHeight] = useState(0);
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);

  const [EachTableAddGuestDialogOpen, setEachTableAddGuestDialogOpen] =
    useState(false);
  const [EachTableAddGuestTableName, setEachTableAddGuestTableName] =
    useState("");
  const [EachTableAddGuestTableId, setEachTableAddGuestTableId] = useState("");
  const [isSmoothReception, setIsSmoothReception] = useState(false);

  useEffect(() => {
    loadArrangementsWithGuests();
    const appbarElement = document.getElementById("appbar");
    if (appbarElement) {
      setAppbarHeight(appbarElement.offsetHeight);
    }
  }, []);

  useEffect(() => {
    const appbarElement = document.getElementById("appbar");
    if (appbarElement) {
      setAppbarHeight(appbarElement.offsetHeight);
    }
  }, [loading]);

  const loadArrangementsWithGuests = async () => {
    setLoading(true);
    try {
      const response = await fetchAllArrangementsWithGuests();
      console.log(response);
      // APIのレスポンスを確認したら、arrangementsを設定
      const arrangementsWithDefaults = response.arrangements.map(
        (arrangement) => ({
          ...arrangement,
          guests: arrangement.guests || [],
        })
      );
      setArrangements(arrangementsWithDefaults);
      setUnarrangedGuests(response.unarranged_guests || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching arrangements with guests:", error);
      setErrorMessage("Error fetching arrangements.");
      setLoading(false);
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false); // 3秒後にメッセージを非表示
      }, 3000);
    }
  };

  const handleAddInvitee = async () => {
    if (!newInvitee.nick_name) {
      setErrorMessage("呼び名は必須です");
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false); // 3秒後にメッセージを非表示
      }, 3000);
      return;
    }

    setButtonLoading(true);
    try {
      await addInvitee(newInvitee);
      await loadArrangementsWithGuests();
      setButtonLoading(false);
      setGuestAddModalIsOpen(false);
      setEachTableAddGuestDialogOpen(false);
      setNewInvitee({
        nick_name: "",
        first_name: "",
        last_name: "",
        gender: "",
        allergy: "",
        arrangement_id: "",
      });
      setSuccessMessage("ゲストの追加成功");
      setOpenSuccess(true);
      setTimeout(() => {
        setOpenSuccess(false); // 3秒後にメッセージを非表示
      }, 3000);
      setErrorMessage(""); // エラーメッセージをリセット
    } catch (error) {
      setButtonLoading(false);
      console.error("Error adding invitee:", error);
      setErrorMessage(error.response?.data?.message || "Error adding invitee."); // エラーメッセージを設定
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false); // 3秒後にメッセージを非表示
      }, 3000);
    }
  };

  const handleAddTable = async () => {
    setButtonLoading(true);
    try {
      await addTable(newTable);
      await loadArrangementsWithGuests(); // 必要に応じてデータをリロード
      setButtonLoading(false);
      setTableModalIsOpen(false);
      setNewTable({ table_name: "", side: "" });
      setSuccessMessage("テーブルの追加成功");
      setOpenSuccess(true);
      setTimeout(() => {
        setOpenSuccess(false); // 3秒後にメッセージを非表示
      }, 3000);
      setErrorMessage(""); // エラーメッセージをリセット
    } catch (error) {
      setButtonLoading(false);
      console.error("Error adding table:", error);
      setErrorMessage(error.response?.data?.message || "Error adding table."); // エラーメッセージを設定
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false); // 3秒後にメッセージを非表示
      }, 3000);
    }
  };

  const handleEditClick = (invitee) => {
    console.log(invitee);
    setEditInvitee(invitee); // 編集対象の招待者を設定
    setOpenAlert(false); // アラートの状態をリセット
    setEditModalIsOpen(true); // 編集モーダルを開く
  };

  const handleEditInvitee = async () => {
    setButtonLoading(true);
    try {
      await updateInvitee(editInvitee);
      setButtonLoading(false);
      await loadArrangementsWithGuests();
      setEditModalIsOpen(false);
      setSuccessMessage("ゲストの編集成功");
      setOpenSuccess(true);
      setTimeout(() => {
        setOpenSuccess(false); // 3秒後にメッセージを非表示
      }, 3000);
      setErrorMessage(""); // エラーメッセージをリセット
    } catch (error) {
      setButtonLoading(false);
      console.error("Error updating invitee:", error);
      setErrorMessage(
        error.response?.data?.message || "Error updating invitee."
      );
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false); // 3秒後にメッセージを非表示
      }, 3000);
    }
  };

  const handleDeleteInvitee = async (targetId) => {
    setButtonLoading(true);
    try {
      await deleteInvitee(targetId);
      setButtonLoading(false);
      setEditModalIsOpen(false);
      setOpenAlert(false);
      await loadArrangementsWithGuests();
      setSuccessMessage("ゲストの削除成功");
      setOpenSuccess(true);
      setTimeout(() => {
        setOpenSuccess(false); // 3秒後にメッセージを非表示
      }, 3000);
      setErrorMessage("");
    } catch (error) {
      setButtonLoading(false);
      console.error("Error delete invitee:", error);
      setErrorMessage(error.response?.data?.message || "Error delete invitee.");
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false); // 3秒後にメッセージを非表示
      }, 3000);
    }
  };

  const handleDeleteTable = async (targetId) => {
    setButtonLoading(true);
    try {
      await deleteTable(targetId);
      setButtonLoading(false);
      setEditModalIsOpen(false);
      setOpenAlert(false);
      await loadArrangementsWithGuests();
      setSuccessMessage("テーブルの削除成功");
      setOpenSuccess(true);
      setTimeout(() => {
        setOpenSuccess(false); // 3秒後にメッセージを非表示
      }, 3000);
      setErrorMessage("");
    } catch (error) {
      setButtonLoading(false);
      console.error("Error delete table:", error);
      setErrorMessage(error.response?.data?.message || "Error delete table.");
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false); // 3秒後にメッセージを非表示
      }, 3000);
    }
  };

  const handleSideChange = async (event, newValue) => {
    setSelectedSide(newValue);
  };

  // 参加状況を変更するハンドラ
  const handleWillChange = (event, newValue) => {
    setSelectedWill(newValue);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredArrangements = arrangements.filter((arrangement) => {
    if (selectedSide === "groom") {
      return arrangement.side === "groom";
    } else if (selectedSide === "bride") {
      return arrangement.side === "bride";
    }
    return true;
  });

  const filteredGuests = (guests) => {
    return guests.filter((invitee) => {
      const willMatch = selectedWill === "all" || invitee.will === selectedWill;
      if (!willMatch) return false;

      const last = invitee.last_name || "";
      const first = invitee.first_name || "";
      const lastF = invitee.last_furigana || "";
      const firstF = invitee.first_furigana || "";
      const nick = invitee.nick_name || "";

      const haystacks = [
        normalizeJP(last + first),
        normalizeJP(first + last),
        normalizeJP(lastF + firstF),
        normalizeJP(firstF + lastF),
        normalizeJP(nick),
        normalizeJP(`${last} ${first} ${lastF} ${firstF} ${nick}`),
      ];

      return tokenizedMatch(searchTerm, haystacks);
    });
  };

  const handleExportCSV = () => {
    try {
      exportGuestsCSV({
        arrangements,
        unarrangedGuests,
        selectedSide,
        selectedWill,
        searchTerm,
        filePrefix: "guests", // 任意
      });
    } catch (e) {
      console.error(e);
      setErrorMessage("CSV出力に失敗しました。");
      setOpenAlert(true);
      setTimeout(() => setOpenAlert(false), 3000);
    }
  };

  return (
    <div className="content">
      {loading ? (
        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1100,
          }}
        >
          <CircularProgress size={60} color="primary" />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              position: "fixed",
              right: 0,
              bottom: 0,
              zIndex: 3000,
              width: "auto",
              maxWidth: "400px",
              padding: 2,
            }}
          >
            <Collapse in={openAlert}>
              <Alert
                variant="filled"
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpenAlert(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                {errorMessage}
              </Alert>
            </Collapse>
          </Box>

          <Box
            sx={{
              position: "fixed",
              right: 0,
              bottom: 0,
              zIndex: 3000,
              width: "auto",
              maxWidth: "400px",
              padding: 2,
            }}
          >
            <Collapse in={openSuccess}>
              <Alert
                variant="filled"
                severity="success"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpenSuccess(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                {successMessage}
              </Alert>
            </Collapse>
          </Box>

          {isSmallScreen ? (
            <AppBar position="fixed" id="appbar">
              <Toolbar>
                <Navbar />
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1, ml: 2 }}
                >
                  ゲスト管理
                </Typography>
                {/* <Button color="inherit">Logout</Button> */}
              </Toolbar>
            </AppBar>
          ) : (
            <Navbar />
          )}

          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            flexDirection={{ xs: "row", sm: "row" }}
            size={12}
          >
            {isSmallScreen ? null : <h2>ゲスト管理</h2>}

            {isSmallScreen ? (
              <Box
                sx={{ marginTop: `${appbarHeight}px` }}
                style={{ width: "100%" }}
              >
                <Grid
                  item
                  container
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <DueSwitchForm
                    setOpenAlert={setOpenAlert}
                    setOpenSuccess={setOpenSuccess}
                    setErrorMessage={setErrorMessage}
                    setSuccessMessage={setSuccessMessage}
                  />
                </Grid>

                <Box className="spacer-md"></Box>

                <Grid
                  item
                  container
                  alignItems="center"
                  spacing={3}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid
                    item
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <TextField
                      size="small"
                      variant="outlined"
                      placeholder="検索..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon /> {/* アイコンを追加 */}
                          </InputAdornment>
                        ),
                      }}
                      style={{ width: "200px" }} // 入力フィールドの幅と右マージンを設定
                    />
                  </Grid>

                  <Grid item container spacing={2}>
                    <Fab
                      size="small"
                      color="primary"
                      onClick={() => setTableModalIsOpen(true)}
                    >
                      <PostAddIcon />
                    </Fab>
                    <Fab
                      size="small"
                      color="primary"
                      onClick={() => setGuestAddModalIsOpen(true)}
                    >
                      <PersonAddIcon />
                    </Fab>
                  </Grid>
                </Grid>
              </Box>
            ) : (
              <Grid
                item
                container
                spacing={3}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* <Button variant="contained" color="primary" startIcon={<PostAddIcon />} onClick={() => setTableModalIsOpen(true)}>
                                テーブルを追加
                            </Button>
                            <Button variant="contained" color="primary" startIcon={<PersonAddIcon />} onClick={() => setModalIsOpen(true)}>
                                招待者を追加
                            </Button> */}

                <DueSwitchForm
                  setOpenAlert={setOpenAlert}
                  setOpenSuccess={setOpenSuccess}
                  setErrorMessage={setErrorMessage}
                  setSuccessMessage={setSuccessMessage}
                />
                {/* <PulseButtonComponent /> */}
              </Grid>
            )}
          </Grid>

          {isSmallScreen ? <Box className="spacer-md"></Box> : null}

          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                flexDirection={{ xs: "column", sm: "row" }}
                size={12}
              >
                <Grid>
                  <GuestFilterTabs
                    selectedSide={selectedSide}
                    handleSideChange={handleSideChange}
                    selectedWill={selectedWill}
                    handleWillChange={handleWillChange}
                    arr={arrangements}
                    unArr={unarrangedGuests}
                  />
                </Grid>
                <Grid
                  container
                  columnSpacing={1}
                  sx={{ order: { xs: 1, sm: 2 } }}
                >
                  {isSmallScreen ? null : (
                    <Grid
                      item
                      container
                      spacing={2}
                      xs={12}
                      md={6}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Grid
                        item
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Stack spacing={2}>
                          <TextField
                            variant="outlined"
                            placeholder="検索..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon /> {/* アイコンを追加 */}
                                </InputAdornment>
                              ),
                            }}
                            style={{ width: "100%" }}
                          />

                          <Stack direction="row" spacing={2}>
                            <Button
                              variant="contained"
                              color="primary"
                              startIcon={<PostAddIcon />}
                              onClick={() => setTableModalIsOpen(true)}
                            >
                              テーブルを追加
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              startIcon={<PersonAddIcon />}
                              onClick={() => setGuestAddModalIsOpen(true)}
                            >
                              招待者を追加
                            </Button>
                          </Stack>
                        </Stack>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Box className="spacer-lg"></Box>

          <Grid container spacing={3} xs={12}>
            <Grid item xs={12} style={{ width: "100%" }}>
              <Grid container spacing={2}>
                {filteredArrangements.map((arrangement) => (
                  <Grid
                    item
                    xs={12}
                    key={arrangement.id}
                    style={{ width: "100%" }}
                  >
                    <div className="guests-table" style={{ width: "100%" }}>
                      <GuestTable
                        invitees={filteredGuests(arrangement.guests)}
                        FRONT_URL={FRONT_URL}
                        handleEditClick={handleEditClick}
                        arr_name={arrangement.arrangement_name}
                        arr_side={arrangement.side}
                        arr_id={arrangement.id}
                        load={loadArrangementsWithGuests}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        openAlert={openAlert}
                        setOpenAlert={setOpenAlert}
                        openSuccess={openSuccess}
                        setOpenSuccess={setOpenSuccess}
                        successMessage={successMessage}
                        setSuccessMessage={setSuccessMessage}
                        setLoading={setButtonLoading}
                        loading={buttonLoading}
                        handleDeleteTable={handleDeleteTable}
                        setGuestAddDialogOpen={setGuestAddModalIsOpen}
                        setEachTableGuestAddDialogOpen={
                          setEachTableAddGuestDialogOpen
                        }
                        setEachTableAddGuestTableName={
                          setEachTableAddGuestTableName
                        }
                        setEachTableAddGuestTableId={
                          setEachTableAddGuestTableId
                        }
                      />
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {selectedSide === "all" && (
              <Grid item xs={12} style={{ width: "100%" }}>
                <div className="guests-table" style={{ width: "100%" }}>
                  <GuestTable
                    invitees={filteredGuests(unarrangedGuests)}
                    FRONT_URL={FRONT_URL}
                    handleEditClick={handleEditClick}
                    arr_name="テーブル未分類"
                    arr_side="N"
                    arr_id=""
                    load={loadArrangementsWithGuests}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    openAlert={openAlert}
                    setOpenAlert={setOpenAlert}
                  />
                </div>
              </Grid>
            )}
          </Grid>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 2, // 上に少し余白
              mb: 2,
            }}
          >
            <Stack direction="column" spacing={2} alignItems="flex-end">
              <SmoothReceptionSwitchForm
                setOpenAlert={setOpenAlert}
                setOpenSuccess={setOpenSuccess}
                setErrorMessage={setErrorMessage}
                setSuccessMessage={setSuccessMessage}
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<FileDownloadIcon />}
                onClick={handleExportCSV}
                sx={{ ml: 1, width: "fit-content" }}
              >
                CSV出力
              </Button>
            </Stack>
          </Box>

          {/* <Button variant="contained" color="primary" onClick={() => setModalIsOpen(true)}>招待者を追加</Button> */}

          {/* 新規ゲスト追加用のモーダル */}
          <AddInviteeDialog
            open={guestAddModalIsOpen}
            onClose={() => setGuestAddModalIsOpen(false)}
            newInvitee={newInvitee}
            setNewInvitee={setNewInvitee}
            onAdd={handleAddInvitee}
            openAlert={openAlert}
            setOpenAlert={setOpenAlert}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            arrangements={arrangements}
            loading={buttonLoading}
          />

          <EachTableAddInviteeDialog
            open={EachTableAddGuestDialogOpen}
            onClose={() => setEachTableAddGuestDialogOpen(false)}
            newInvitee={newInvitee}
            setNewInvitee={setNewInvitee}
            onAdd={handleAddInvitee}
            openAlert={openAlert}
            setOpenAlert={setOpenAlert}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            arrangements={arrangements}
            loading={buttonLoading}
            arrangement_name={EachTableAddGuestTableName}
            arrangement_id={EachTableAddGuestTableId}
          />

          {/* テーブル追加用のモーダル */}
          <AddTableDialog
            open={tableModalIsOpen}
            onClose={() => setTableModalIsOpen(false)}
            newTable={newTable}
            setNewTable={setNewTable}
            onAdd={handleAddTable}
            openAlert={openAlert}
            setOpenAlert={setOpenAlert}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            loading={buttonLoading}
          />

          {/* ゲスト編集用モーダル */}
          <EditInviteeDialog
            open={editModalIsOpen}
            onClose={() => setEditModalIsOpen(false)}
            editInvitee={editInvitee}
            setEditInvitee={setEditInvitee}
            onEdit={handleEditInvitee} // 編集処理を渡す
            openAlert={openAlert} // アラートの状態を渡す
            setOpenAlert={setOpenAlert} // アラートの状態を変更する関数を渡す
            errorMessage={errorMessage}
            arrangements={arrangements} // アレンジメントを渡す
            loading={buttonLoading}
            handleDeleteInvitee={handleDeleteInvitee}
          />

          {/* リンク表示用のモーダル */}
          <Modal
            isOpen={linkModalIsOpen}
            onRequestClose={() => setLinkModalIsOpen(false)}
          >
            <h2>招待状URL</h2>
            <p>{currentLink}</p>
            <button onClick={() => setLinkModalIsOpen(false)}>閉じる</button>
          </Modal>
        </>
      )}
    </div>
  );
};

export default GuestsManage;
